export default __webpack_public_path__ + "static/media/member4.7f97f624.jpg";